import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import { MAINTENANCE_ROUTE } from '@rci/self-serve-fido/app.constant';
import { AccountListFacadeService } from '@rogers/self-serve-common/account';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EnsureNoGlobalApiErrorGuard implements CanActivate {
  private readonly accountListFacadeService = inject(AccountListFacadeService);
  private readonly routingService = inject(RoutingService);

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.accountListFacadeService.isAccountListLoading$.pipe(
      filter(loading => loading === false),
      switchMap(_ =>
        this.accountListFacadeService.accountListError$.pipe(
          map(accountListError => {
            if (accountListError) {
              this.routingService.navigate(MAINTENANCE_ROUTE);
            }
            return !accountListError;
          }),
        ),
      ),
    );
  }
}
